var isPage = "";
var Animate = {
	top: 0,
	show: 0,
	id: 0
}
var animations = [];
var common = {
	init: ()=>{
		var resizeFlag;
		var resizeTimer = null;
		var $body = $("body");

		if(isPage === "top"){
			morph.init();
		}else{
			setTimeout(function(){
				$body.removeClass("disable");
			},600);
		}
		btm.init();
		common.resize();
		common.nav();
		bg.init();
		common.scrl();
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};

		$(window).off("resize").on("resize",function(){
			if(!$body.hasClass("resize")){
				$body.addClass("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
		$(document).on("scroll touchmove", function(){
			common.scrl();
		});
	},
	nav: ()=>{
		var $body = $("body");
		$("#btn_menu").off().on("click", function(){
			if(!$body.hasClass("show_menu")){
				$body.addClass("show_menu");
				$("#btn_menu").removeClass("shake");
				setTimeout(function(){
					$body.addClass("active_menu");
				},500);
			}else{
				$body.removeClass("active_menu");
				setTimeout(function(){
					$body.removeClass("show_menu");
					$("#btn_menu").addClass("shake");
				},500);
			}
		});
		$(".pagetop a").off().on("click", function(){
			common.scrollToPosition(0, 1000);
		});
		//share
		$(".sharewith li a").off().on("click", function(){
			$this = $(this);
			var idx = $(".sharewith li a").index(this);
			var url = $(this).attr("data-share");
			shareTxt(idx,url);
		});
		function shareTxt(num,shareUrl){
			var domain = "http://" + document.domain;
			var url 	= domain + shareUrl;
			if(num === 0){
				//Twitter
				var txt = $this.attr("data-text");
				window.open(
					'http://twitter.com/share?url=' + encodeURIComponent(url) + "&amp;text=" + encodeURIComponent(txt),
					'twittersharedialog',
					'width=626,height=436');
			}else if(num === 1){
				//Facebook
				window.open(
					'http://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
					'facebooksharedialog',
					'width=626,height=436');
			}else{
				//LINE
				var txt = $this.attr("data-text") + "\n" + url;
				window.open(
					'http://line.me/R/msg/text/?' + encodeURIComponent(txt),
					'linesharedialog',
					'width=626,height=436');
			}
		}
	},
	resize: ()=>{
		var $bg 	= $("#bg_canvas");
		var winW 	= window.innerWidth;
		var winH 	= window.innerHeight;
		var $body = $("body");

		prevIsSmallScreen = isSmallScreen;
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if(prevIsSmallScreen != isSmallScreen){
			if(hasBG){
				//bg.ctx.clearRect(0,0,bg.w, bg.h);
				//bg.count = 0;
				//bg.init();
			}
		}
		prevIsSmallScreen = isSmallScreen;
		var cw = winW*devicePixelRatio;
		var ch = $(document).height()*devicePixelRatio;
		bg.w = cw;
		bg.h = ch;
		$bg.attr("width", winW + "px");
		$bg.attr("height", $(document).height() + "px");
		$bg.css({
			"width" : String( cw / devicePixelRatio) + "px",
			"height": String( ch / devicePixelRatio) + "px"
		});
		$(".bg_wrap").css({
			"height": ""
		});
		$(".bg_wrap").css({
			"height": $(document).height() + "px"
		});
		common.checkPosition();
		if(isPage === "top"){
			morph.resize();
		}
		common.scrl();
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
	},
	checkPosition: function(){
		animations = [];
		$(".a").each(function(i){
			var _a = object(Animate);
			_a.top 	= Math.floor($(this).offset().top);
			_a.show = Math.floor(_a.top + $(window).height()/3);
			_a.id 	= $(this).attr("id");
			animations.push(_a);
		});
	},
	load: function(url, params){
		var defer 	= $.Deferred();
		var url 	= url;
		$.ajax({
			type: "GET",
			dataType: 'json',
			url: url,
			data: params,
			success	: defer.resolve,
			error: defer.reject
		});
		return defer.promise();
	},
	scrollToPosition: (posY, time) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic",
			flag 	= true;
		$page.animate({
			scrollTop : posY + "px"
		},{
			"duration" 	: time,
			"easing" 	: ease
		});
	},
	scrl: () =>{
		var topD = $(document).scrollTop(),
			btmD = topD + $(window).height(),
			alen = animations.length;

		for(var a = 0; a < alen; a++){
			if(a === alen - 1){
				if(btmD >= animations[a].show){
					activeBlock(a)
				}
			}else{
				if(btmD >= animations[a].show){
					activeBlock(a)
				}
			}
		}
		function activeBlock(a){
			var $block = $(".a").eq(a);
			if(!$block.hasClass("animate")){
				$block.addClass("animate");
				setTimeout(function(){
					$block.addClass("animated");
				},1000);
			}
		}
		if(isSmallScreen){
			var posY = topD*-0.05;
		}else{
			var posY = topD*-1.05;
		}
		
		$("#bg3").css({
			"background-position": 'center ' + posY + 'px'
		});
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	common.init();
});